import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import { TerritoryOptions } from "../../Constants/retailer";
import "./index.css";

const UKIcon = require("../../assets/media/countries/uk.png");
const USAIcon = require("../../assets/media/countries/usa.png");
const IrelandIcon = require("../../assets/media/countries/ireland.png");
const CanadaIcon = require("../../assets/media/countries/canada.png");
const AustraliaIcon = require("../../assets/media/countries/australia.png");
const FranceIcon = require("../../assets/media/countries/france.png");
const GermanIcon = require("../../assets/media/countries/german.png");
const IndiaIcon = require("../../assets/media/countries/india.png");
const SouthAfricaIcon = require("../../assets/media/countries/south-africa.png");

const TerritoryIcon = {
  UK: UKIcon,
  USA: USAIcon,
  Ireland: IrelandIcon,
  Canada: CanadaIcon,
  Australia: AustraliaIcon,
  German: GermanIcon,
  France: FranceIcon,
  India: IndiaIcon,
  SouthAfrica: SouthAfricaIcon,
};
const Retailer = ({ number, options, top20Retailers, onChange }) => {
  const [retailer, setRetailer] = useState({ value: false, label: "None" });
  useEffect(() => {
    const retailer = top20Retailers.find(
      (retailer) => retailer.top20 == number
    );
    if (retailer)
      setRetailer({ value: retailer, label: retailer.retailerName });
    else setRetailer({ value: false, label: "None" });
  }, [top20Retailers]);
  function handleChangeRetailer(newretailer) {
    console.log("1", retailer);
    console.log("2", newretailer);
    setRetailer(newretailer);
    if (retailer.value) {
      onChange(
        { id: retailer.value.id, top20: false },
        retailer.value.voucherType
      );
      if (newretailer.value)
        onChange(
          { id: newretailer.value.id, top20: number },
          newretailer.value.voucherType
        );
    } else {
      if (newretailer.value)
        onChange(
          { id: newretailer.value.id, top20: number },
          newretailer.value.voucherType
        );
    }
  }
  return (
    <div className="row-div mb-3">
      <p>{number}</p>
      &nbsp;&nbsp;&nbsp;
      <div className="retailer_option">
        <Select
          value={retailer}
          onChange={handleChangeRetailer}
          options={options}
          isSearchable={true}
        />
      </div>
      &nbsp;&nbsp;&nbsp;
      {retailer.value && (
        <div className="logo-div">
          <div
            className="logo-img"
            style={{
              backgroundImage: `url(${retailer ? retailer.value.logo : ""})`,
            }}
          />
        </div>
      )}
    </div>
  );
};
const Retailers = ({ territory, retailers, deactive }) => {
  const filtered = retailers.filter((retailer) => {
    if (retailer.voucherType === "neocurrency") {
      return retailer.territory === territory && retailer.isActive;
    }
    return retailer.territory === territory && !deactive[retailer.id];
  });
  const options = filtered
    .filter((filtered_retailer) => !filtered_retailer.top20)
    .map((retailer) => {
      return { value: retailer, label: retailer.retailerName };
    });
  options.unshift({ value: false, label: "None" });
  const top20Retailers = filtered.filter((retailer) => retailer.top20);

  function updateTop(payload, voucherType) {
    console.log("top 20", payload, voucherType);
    if (voucherType === "neocurrency") {
      Firebase.updateNCRetailer({ top20: payload.top20 }, payload.id);
    } else {
      Firebase.updateRetailer({ top20: payload.top20 }, payload.id);
    }
  }
  return (
    <div className="row">
      <div className="col-md-6 retailers">
        {[...Array(15).keys()].map((element) => {
          return (
            <Retailer
              number={element + 1}
              options={options}
              top20Retailers={top20Retailers}
              onChange={updateTop}
            />
          );
        })}
      </div>
      <div className="col-md-6 retailers">
        {[...Array(15).keys()].map((element) => {
          return (
            <Retailer
              number={element + 16}
              options={options}
              top20Retailers={top20Retailers}
              onChange={updateTop}
            />
          );
        })}
      </div>
    </div>
  );
};
class TopRetailers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      deactive: [],
      tag: "",
      selectedTerritory: TerritoryOptions[0],
    };
  }
  componentDidMount() {
    if (!this.props.location.state && this.props.location.state.role !== 0) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
    }
    Firebase.getAllRetailers((res) => {
      const keys = Object.keys(res);
      const wgRetailers = keys.map((key) => ({
        ...res[key],
        id: key,
      }));
      Firebase.getAllNCRetailers((res) => {
        const keys = Object.keys(res);
        const ncRetailers = keys.map((key) => ({
          ...res[key],
          id: key,
        }));
        const retailers = [...wgRetailers, ...ncRetailers];
        retailers.sort((a, b) => {
          var textA = a.retailerName.toUpperCase();
          var textB = b.retailerName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        this.setState({ retailers });
      });
    });
    Firebase.getAllDeactiveRetailers((res) => {
      let deactive = [];
      if (res) deactive = res;
      this.setState({ deactive });
    });
  }

  territoryFilterUpdated = (selectedTerritory) => () => {
    this.setState({ selectedTerritory });
  };

  render() {
    const { retailers, deactive, logo, brand, selectedTerritory } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <main id="main-container">
          <div className="content">
            {retailers.length ? (
              <React.Fragment>
                <div className="territory-filter-container">
                  {TerritoryOptions.map((territory) => (
                    <button
                      className={classNames("btn territory-btn", {
                        selected: selectedTerritory === territory,
                      })}
                      onClick={this.territoryFilterUpdated(territory)}
                    >
                      <img src={TerritoryIcon[territory]} alt="flag" />
                    </button>
                  ))}
                </div>
                <Retailers
                  territory={selectedTerritory}
                  retailers={retailers}
                  deactive={deactive}
                />
              </React.Fragment>
            ) : (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            )}
          </div>
        </main>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapActionToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapActionToProps)(TopRetailers);



// WEBPACK FOOTER //
// ./src/screens/TopRetailers/index.js